import { render, staticRenderFns } from "./allotment-update-base.vue?vue&type=template&id=b0ba0e70"
import script from "./allotment-update-base.vue?vue&type=script&lang=js"
export * from "./allotment-update-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports